import { render, staticRenderFns } from "./Transferir.vue?vue&type=template&id=4ebb2738"
import script from "./Transferir.vue?vue&type=script&lang=js"
export * from "./Transferir.vue?vue&type=script&lang=js"
import style0 from "./Transferir.vue?vue&type=style&index=0&id=4ebb2738&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports